module.exports = __webpack_public_path__ + "img/explain.76877f46.svg";